import Link from './Link.client'
import { Links } from '@/src/generated/graphql'
import { normalizedUrlPath } from '@/src/helpers/url'

export default Link

type InternalPageUrlParamsType = {
  url_param_key: string
  url_param_value: string
}

export const convertDirectusLinkToHref = (_: Links) => {
  const internal_page_url_params = _.internal_page_url_params as InternalPageUrlParamsType[]
  return (
    _.remote_url ??
    (_.internal_page?.slug
      ? normalizedUrlPath(_.internal_page.slug) +
        (internal_page_url_params?.length
          ? '?' +
            internal_page_url_params
              .map(param => param.url_param_key + '=' + param.url_param_value)
              .join('&')
          : '') +
        (_.internal_page_url_hash ? '#' + _.internal_page_url_hash : '')
      : null) ??
    null
  )
}
